jQuery(document).ready(function($){
	$('body').on('click', '.read-more-btn', function(){
      $('.show-more').toggle('slow');
    });
  
  
  $('.read-more-btn').click(function(){
    var $this = $(this);
    $this.toggleClass('js-more');
    if($this.hasClass('js-more')){
        $this.text('Read More...');         
    } else {
        $this.text('Minimize');
    }
  });
  
  $('.collection-slider .shg-category .shg-category-row-hor').flickity({
  // options
    cellAlign: 'left',
    contain: true,
    groupCells: 3,
    prevNextButtons: false,
    imagesLoaded: true,
  });

  
});



